import { isDesktopBrowserDifferentFromChrome, isMobileBrowser } from '../../utils/platform';

export * from './GooglePayLoader';
export * from './GooglePayState';
export * from './GooglePay';

export const loadingModalCanBeDisplayedInTheGooglePayFlow = (): boolean => isDesktopBrowserDifferentFromChrome || isMobileBrowser;
